<script setup>
import { defineEmits, inject, onMounted } from "vue";
import { useBookingSettingsStore } from "../../stores/bookingStore";

defineEmits(["editClick"]);

const $storage = inject("$storage");

const bookingSettingsStore = useBookingSettingsStore();

const props = defineProps({
    allowEdit: {
        type: Boolean,
        default: false,
    },
});

const getBookingSettingsText = (changedKey) => {
    if (bookingSettingsStore.isFirstActivity) {
        return "Created";
    }

    if (bookingSettingsStore.isBookingSettingsChanged[changedKey]) {
        return "Changed";
    }

    return "Default";
};

onMounted(() => {
    bookingSettingsStore.getLocalStorage($storage);
});
</script>

<template>
    <div class="d-flex flex-column mt-3r"
         data-test="summary-booking-settings">
        <div class="d-flex flex-row justify-content-between">
            <div class="simple-event-title" data-test="summary-price-title">Booking settings</div>
            <div
                v-if="props.allowEdit"
                @click="$emit('editClick', 'booking-settings')"
                class="card-text cursor-pointer"
                data-test="summary-booking-settings-edit">
                Edit
            </div>
        </div>

        <div class="d-flex flex-row justify-content-between mt-3 pl-3" data-test="summary-refund-policy">
            <div>Refund policy</div>
            <div class="event-data">{{ getBookingSettingsText("isRefundPolicyChanged") }}</div>
        </div>

        <div class="d-flex flex-row justify-content-between mt-3 pl-3" data-test="summary-terms-conditions">
            <div>Terms and conditions</div>
            <div class="event-data">{{ getBookingSettingsText("isTermsConditionsChanged") }}</div>
        </div>

        <div class="d-flex flex-row justify-content-between mt-3 pl-3" data-test="summary-resale-policy">
            <div>Resale policy</div>
            <div class="event-data">{{ getBookingSettingsText("isResalePolicyChanged") }}</div>
        </div>

        <div class="d-flex flex-row justify-content-between mt-3 pl-3" data-test="summary-privacy-policy">
            <div>Privacy policy</div>
            <div class="event-data">{{ getBookingSettingsText("isPrivacyPolicyChanged") }}</div>
        </div>
    </div>
</template>
